import {
  AnalyticsProps,
  NOT_TRACKED_CONTENT,
} from '../../InternalLibrary/analytics';
import {
  default as FieldGroup,
  FieldGroupProps,
} from 'components/atoms/FieldGroup/FieldGroup';
import { default as Select, SelectProps } from 'components/atoms/Select/Select';
import { useAnalytics } from 'use-analytics';
import { useCallback } from 'react';
import { useFormik } from 'formik';
import { useValidationText } from 'hooks/useValidationText';

export interface SelectActorProps extends AnalyticsProps {
  className?: string;
  formik: ReturnType<typeof useFormik<any>>;
  name: string;
  label: string;
  fieldGroupProps?: Omit<FieldGroupProps, 'children'>;
  selectProps?: Partial<SelectProps>;
}

export const SelectActor: React.FC<SelectActorProps> = ({
  className,
  formik,
  name,
  label,
  fieldGroupProps = {},
  selectProps = {},
  analytics,
}) => {
  const { track } = useAnalytics();

  const onChange = useCallback(
    (e: any) => {
      formik.status?.errors?.[name] && delete formik.status.errors[name];
      formik.handleChange(e);

      if (analytics?.dontTrack) {
        return;
      }

      track('select', {
        description: analytics?.description,
        inputPlaceholder: label,
        value: analytics?.dontTrackContent
          ? NOT_TRACKED_CONTENT
          : analytics?.contentOverride ?? e.target.value,
      });
    },
    [
      analytics?.contentOverride,
      analytics?.description,
      analytics?.dontTrack,
      analytics?.dontTrackContent,
      formik,
      label,
      name,
      track,
    ],
  );

  return (
    <FieldGroup
      className={className}
      validationText={useValidationText(formik, name)}
      {...fieldGroupProps}
    >
      <Select
        {...selectProps}
        dataTest={`select-${name}`}
        label={label}
        name={name}
        onChange={onChange}
        onBlur={formik.handleBlur}
        value={formik.values[name]}
      />
    </FieldGroup>
  );
};
